export const ApiQueryKey = {
	products: 'products',
	productTypes: 'product-types',

	admins: 'admins',
	users: 'users',

	roles: 'roles',
	contents: 'contents',
	userContents: 'user-contents',
	userComponents: 'user-components',
	montageSystems: 'montage-systems',
	montageTypes: 'montage-types',
	accessories: 'accessories',
	productColors: 'product-colors',
	components: 'components',

	stores: 'stores',
	drivers: 'drivers',
	powerSupplies: 'power-supplies',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
